import { render, staticRenderFns } from "./GatherChannel.vue?vue&type=template&id=f755152a&scoped=true&"
import script from "./GatherChannel.vue?vue&type=script&lang=ts&"
export * from "./GatherChannel.vue?vue&type=script&lang=ts&"
import style0 from "./GatherChannel.vue?vue&type=style&index=0&id=f755152a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f755152a",
  null
  
)

export default component.exports